import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import Toggle from './Toggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SpinnerCircles from './Spinner/SpinerCircles';
import {
  addOobCategory,
  getOobCategoryList,
  createSshUserProfile,
  fetchAndAssignUsbs,
  fetchAvailableOobBTNs,
  fetchTtyData,
} from '../actions/EpikBoxes';
import AddOobCategoryModal from './AddOobCategoryModal';
import { toast } from 'react-toastify';
import CustomWarning from './CustomWarning';
import { useUnifiedFetch, useUnifiedMutate } from '../hooks';
import { getPermissionForComponent } from '../utils/permissionsUtils';

const USB_SPEED_OPTIONS = [
  1200,
  2400,
  4800,
  9600,
  19200,
  38400,
  57600,
  115200,
  230400,
  460800,
  921600,
];
const USB_DATA_BITS_OPTIONS = [5, 7, 8];
const USB_STOP_BITS_OPTIONS = [1, 2];
const USB_PARITY_OPTIONS = ['None', 'Odd', 'Even', 'Mark', 'Space'];
const USB_FLOW_CONTROL_OPTIONS = ['None', 'Xon', 'Rts'];

const OobmEditMode = ({ isOpen, onClose, apiResponse, dbResponse, box, mode }) => {
  const nationalFormatedNumber = dbResponse?.number?.replace(/^\+1/, '');
  const currentUsbPort =
    (Object.keys(apiResponse)?.length && apiResponse[nationalFormatedNumber]) || null;
  const status = !currentUsbPort ? dbResponse?.allowTTY : currentUsbPort?.ttyStatus === 'true';

  const assignedUsbs = useSelector(state => state.AppState.boxDetails.oobList.assignedUsbs);

  // Filter out assigned USBs that are not in disconnected USBs
  const activeUsbs = assignedUsbs?.filter(assignedUsb => !assignedUsb?.disconnected);

  const oobOrderedBtns = useSelector(state => state.AppState.boxDetails.oobOrderedBtns);
  const user = useSelector(state => state.AppState.user);

  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;
  const [loading, setLoading] = useState(false);
  const [loadingFor, setLoadingFor] = useState('');
  const [publicKey, setPublicKey] = useState('');
  const [categoriesList, setCategoriesList] = useState([]);
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [speed, setSpeed] = useState(currentUsbPort?.Speed || '9600');
  const [dataBits, setDataBits] = useState(currentUsbPort?.dbits || '8');
  const [stopBits, setStopBits] = useState(currentUsbPort?.sbits || '1');
  const [parity, setParity] = useState(currentUsbPort?.parity || 'None');
  const [flowControl, setFlowControl] = useState(currentUsbPort?.flowC || 'None');
  const [usbPort, setUsbPort] = useState(dbResponse?.usbPort?.title || '');
  const [endpoint, setEndpoint] = useState(dbResponse?.usbPort?.customTitle || '');
  const [category, setCategory] = useState(dbResponse?.usbPort?.usbCategory?._id || '');
  const [allowTTY, setAllowTTY] = useState(status);
  const [ttyPassword, setTtyPassword] = useState(dbResponse?.usbPort?.ttyPassword || '');
  const [showPassword, setShowPassword] = useState(false);
  const [isUsbAssigned, setIsUsbAssigned] = useState(null);
  const [ttyDisable, setTtyDisable] = useState(false);
  const [selectedUsbPort, setSelectedUsbPort] = useState(currentUsbPort || null);
  const ttyOptionsAccess = getPermissionForComponent('ttyOptionsAccess',user.permissionsGroup)
  const [disconnectAlert, setDisconnectAlert] = useState(
    dbResponse?.usbPort?.disconnectAlert ?? false
  );

  const { data: btnPublicKey, fetchData: fetchingPublicKey } = useUnifiedFetch(
    `oob/${box?._id}/publickey/${dbResponse?.number}`,
    false,
  );

  const { data: oobmPortProfiles, fetchData: fetchingOobmProfiles } = useUnifiedFetch(
    `oob/${box?._id}/fetchSavedProfiles`,
    false,
  );

  const { mutate: toggleBtnTtyAccess, isLoading: ttyIsLoading } = useUnifiedMutate();

  useEffect(() => {
    const fetchPublicKey = async () => {
      if (dbResponse?.usbPort?.allowTTY && dbResponse?.number) {
        const resp = await fetchingPublicKey();
        if (!resp?.status) {
          toast.error(resp?.message);
        }
      }
    };

    fetchPublicKey();
    // Dependency array includes specific parts of dbResponse that are needed
  }, [dbResponse?.usbPort?.allowTTY, dbResponse?.number, fetchingPublicKey]);

  useEffect(() => {
    setPublicKey(btnPublicKey);
  }, [btnPublicKey]);

  const getOobCategories = async () => {
    console.log('box is :', box);
    const response = await dispatch(getOobCategoryList(token, box._id, box.assignedTo._id));
    console.log('response is :', response);
    let catArray = [{ label: 'Select category', value: '' }];
    if (response) {
      (response || []).map(item => catArray.push({ label: item.title, value: item._id }));
      setCategoriesList(catArray);
    }
  };

  useEffect(() => {
    getOobCategories();
  }, []);

  const interfaceChangeHandler = e => {
    const isPortAlreadyAssigned = oobOrderedBtns?.some(
      btn => btn?.usbPort?.title === e.target.value,
    );

    if (isPortAlreadyAssigned) {
      console.log('usbPort already assigned');
      setIsUsbAssigned(e.target.value);
      return;
    }

    setUsbPort(e.target.value);
  };

  const addNewCategoryHandler = async inputText => {
    setLoading(true);
    const params = { company: box.assignedTo._id, categoryTitle: inputText };
    const res = await dispatch(addOobCategory(token, box._id, params));
    console.log('respone is ', res);
    if (res.error) {
      setError(res.error);
    } else if (res?.data) {
      setError('');
      setSuccess('Category added.');
      setCategoriesList([...categoriesList, { label: res?.data?.title, value: res?.data?._id }]);
      setTimeout(() => {
        setSuccess('');
      }, 2000);
    }
    setLoading(false);
  };

  const refreshOobmInfo = async () => {
    console.log('refresh info.');

    await dispatch(fetchTtyData(token, box?._id));
    await dispatch(fetchAndAssignUsbs(token, box?._id));
    await dispatch(fetchAvailableOobBTNs(token, box?._id));
  };

  const saveUserProfile = async () => {
    if (!dbResponse?.number) {
      toast.info(`Please select any BTN to proceed.`);
      return;
    }

    if (allowTTY && !ttyPassword && (ttyOptionsAccess === 'write' || ttyOptionsAccess === 'both') ) {
      toast.info(`Please set TTY Password to proceed.`);
      return;
    }

    if (!usbPort) {
      toast.info(`Please select USB interface.`);
      return;
    }

    setLoading(true);
    setLoadingFor('save');

    const payload = {
      btn: dbResponse?.number,
      endpoint,
      category,
      speed,
      dataBits,
      stopBits,
      parity,
      flowControl,
      ttyPassword,
      allowTTY,
      publicKey,
      usbportno: usbPort,
      disconnectAlert,
    };

    const respone = await dispatch(createSshUserProfile(token, box?._id, payload));
    if (respone) await refreshOobmInfo();

    if (!selectedUsbPort) {
      const resp = await fetchingOobmProfiles();
      if (!resp?.status) {
        toast.error(resp?.message);
      }
    }

    if (selectedUsbPort && respone) {
      onClose();
    }

    setLoading(false);
    setLoadingFor('');
  };

  useEffect(() => {
    if (oobmPortProfiles) {
      const currentUsbPort = oobmPortProfiles[dbResponse?.number?.replace(/^\+1/, '')];
      setSelectedUsbPort(currentUsbPort);
      setSpeed(currentUsbPort?.Speed);
      setDataBits(currentUsbPort?.dbits);
      setStopBits(currentUsbPort?.sbits);
      setParity(currentUsbPort?.parity);
      setFlowControl(currentUsbPort?.flowC);
      setAllowTTY(currentUsbPort?.ttyStatus === 'true');
    }
  }, [oobmPortProfiles]);

  const toggleTtyAccess = async action => {
    console.log('TTY Toggle', action);

    if (ttyIsLoading) {
      return;
    }

    setLoading(true);
    setLoadingFor('ttytoggle');

    const endpoint = `oob/${box?._id}/tty-access`;
    const method = 'PUT';
    const payload = {
      boxId: box?._id,
      isBoxTab: true,
      did: dbResponse?.number,
      toggle: action,
    };

    const resp = await toggleBtnTtyAccess({
      isMyEpik: false,
      endpoint,
      method,
      body: payload,
    });

    if (resp) {
      await refreshOobmInfo();
      setAllowTTY(!allowTTY);
      setTtyDisable(false);
    }
    setLoading(false);
    setLoadingFor('');
  };

  const ttyAccessHandler = () => {
    if (!!allowTTY) {
      console.log('toggle disable occur');
      setTtyDisable(true);
    } else {
      toggleTtyAccess('enable');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} style={{ maxWidth: '70%' }} className="edit-oobm-mode">
      <ModalHeader
        toggle={onClose}
        tag="div"
        style={{ padding: '0.5rem 0.5rem', alignItems: 'center' }}
      >
        <span style={{ fontWeight: 'bold', fontSize: '1rem' }}>
          OOBM - {mode} Mode ({dbResponse?.number})
        </span>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md="4">
            <FormGroup>
              <Label for="interface">USB Interface</Label>
              <Input
                type="select"
                name="interface"
                id="interface"
                value={usbPort}
                onChange={e => interfaceChangeHandler(e)}
              >
                <option value="">
                  {!activeUsbs?.length ? 'No USB Detected' : 'Select USB Interface'}
                </option>
                {activeUsbs?.map(usb => (
                  <option key={usb?.title} value={usb?.title} selected={usb?.title === usbPort}>
                    {usb?.title}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <Label for="endpoint">Endpoint</Label>
              <Input
                type="text"
                name="endpoint"
                id="endpoint"
                value={endpoint}
                onChange={e => setEndpoint(e.target.value)}
                placeholder="Enter Endpoint"
              />
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <Label for="category">Category</Label>
              <button
                type="button"
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'blue',
                  cursor: 'pointer',
                  float: 'right',
                }}
                onClick={() => setAddCategoryModal(true)}
              >
                Add Category
              </button>

              <Input
                type="select"
                name="category"
                id="category"
                value={category}
                onChange={e => setCategory(e.target.value)}
              >
                {categoriesList?.map(({ label, value }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md="2">
            <FormGroup>
              <Label for="speed">Speed</Label>
              <Input
                type="select"
                name="speed"
                id="speed"
                value={speed}
                onChange={e => setSpeed(e.target.value)}
              >
                <option value="">Select Speed</option>
                {USB_SPEED_OPTIONS.map(speed => (
                  <option key={speed} value={speed}>
                    {speed}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label for="dataBits">Data Bits</Label>
              <Input
                type="select"
                name="dataBits"
                id="dataBits"
                value={dataBits}
                onChange={e => setDataBits(e.target.value)}
              >
                <option value="">Select Data Bits</option>
                {USB_DATA_BITS_OPTIONS.map(bits => (
                  <option key={bits} value={bits}>
                    {bits}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label for="stopBits">Stop Bits</Label>
              <Input
                type="select"
                name="stopBits"
                id="stopBits"
                value={stopBits}
                onChange={e => setStopBits(e.target.value)}
              >
                <option value="">Select Stop Bits</option>
                {USB_STOP_BITS_OPTIONS.map(bits => (
                  <option key={bits} value={bits}>
                    {bits}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label for="flowControl">Flow Control</Label>
              <Input
                type="select"
                name="flowControl"
                id="flowControl"
                value={flowControl}
                onChange={e => setFlowControl(e.target.value)}
              >
                <option value="">Select Flow Control</option>
                {USB_FLOW_CONTROL_OPTIONS.map(control => (
                  <option key={control} value={control}>
                    {control}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <Label for="parity">Parity</Label>
              <Input
                type="select"
                name="parity"
                id="parity"
                value={parity}
                onChange={e => setParity(e.target.value)}
              >
                <option value="">Select Parity</option>
                {USB_PARITY_OPTIONS.map(parityOption => (
                  <option key={parityOption} value={parityOption}>
                    {parityOption}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          {/* Endpoint Disconnect Alerting */}
          <Col md="4" className="d-flex align-items-center justify-content-between">
            <label className="mt-3 mb-3">Endpoint Disconnect Alerting</label>
            <Toggle
              value={disconnectAlert}
              disabled={!usbPort}
              onToggle={() => setDisconnectAlert(prev => !prev)}
              customDisableText={
                !usbPort
                  ? 'Please select USB interface first.'
                  : undefined
              }
            />
          </Col>
        </Row>

        {/* Allow TTY Access Section */}
        {ttyOptionsAccess && 
          <Row style={{ marginTop: '20px', padding: '10px 0px', borderTop: '1px solid #ccc' }}>
          <Col md="3" className="d-flex align-items-center justify-content-between">
            <label className="mt-3 mb-3"> Allow TTY Access </label>
            {loading && loadingFor === 'ttytoggle' && !allowTTY ? (
              <div className="d-flex justify-content-between align-items-center">
                <SpinnerCircles red />
              </div>
            ) : (
              <Toggle
                value={allowTTY}
                disabled={loading || !selectedUsbPort || (false|| ttyOptionsAccess == 'read')}
                onToggle={() => {
                  if (ttyOptionsAccess === 'write' || ttyOptionsAccess === 'both') {
                    ttyAccessHandler()
                  }
                }}
                customDisableText={
                  ((false) || ttyOptionsAccess == 'read')
                    ? 'You do not have permission to perform this action.'
                    : 'Please create profile to enable TTY access.'
                }
              />
            )}
          </Col>
          {allowTTY && (
            <>
              <Col md="5" className="d-flex align-items-center justify-content-between">
                <Label className="mt-2 mr-3">Password:</Label>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  name="ttyPassword"
                  id="ttyPassword"
                  value={ttyPassword}
                  onChange={e => setTtyPassword(e.target.value)}
                  autoComplete="new-password"
                  disabled={ttyOptionsAccess == 'read'}
                />
                <FontAwesomeIcon
                  icon={showPassword ? 'eye' : 'eye-slash'}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: 'pointer', marginLeft: 10 }}
                  size="lg"
                  color="#8998ac"
                />
              </Col>
            </>
          )}
        </Row>
        }

        {/* SSH Public Key (Optional) Section */}
        {(ttyOptionsAccess === 'write' || ttyOptionsAccess === 'both') && allowTTY && (
          <Row style={{ marginTop: '20px' }}>
            <Col md="12">
              <FormGroup>
                <Label for="publicKey">SSH Public Key (Optional)</Label>
                <Input
                  type="textarea"
                  name="publicKey"
                  id="publicKey"
                  placeholder="Enter SSH public key here"
                  value={publicKey}
                  onChange={e => setPublicKey(e.target.value)}
                  rows={3}
                />
                <small>
                  Note: RSA Based Keys are not recommended (CVE-2005-4900). We suggest ECDSA /
                  Ed25519.
                </small>
              </FormGroup>
            </Col>
          </Row>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button color="primary" disabled={loading || !usbPort} onClick={() => saveUserProfile()}>
          {loading && loadingFor === 'save' ? (
            <SpinnerCircles />
          ) : !selectedUsbPort ? (
            'Create Profile'
          ) : (
            'Save'
          )}
        </Button>
      </ModalFooter>

      {addCategoryModal && (
        <AddOobCategoryModal
          error={error}
          success={success}
          isOpen={addCategoryModal}
          loading={loading}
          onSubmit={addNewCategoryHandler}
          cancelHandler={() => setAddCategoryModal(false)}
        />
      )}

      {isUsbAssigned && (
        <CustomWarning
          isOpen={isUsbAssigned}
          onConfirm={() => {
            setUsbPort(isUsbAssigned);
            setIsUsbAssigned(null);
          }}
          onCancel={() => setIsUsbAssigned(null)}
          customText="Yes"
          customCancelText="No"
        >
          This port is already assigned to another BTN. Do you still want to continue?
        </CustomWarning>
      )}

      {ttyDisable && (
        <CustomWarning
          isOpen={ttyDisable}
          onConfirm={() => {
            toggleTtyAccess('disable');
          }}
          onCancel={() => setTtyDisable(false)}
          customText="Yes"
          customCancelText="No"
          loading={loading}
        >
          Are you sure you want to disable TTY access?
        </CustomWarning>
      )}
    </Modal>
  );
};

export default OobmEditMode;
